import React, { useContext, useEffect, useState } from "react";
import opdContext from "../../context/opdContext/opdContext";
import authContext from "../../context/authentication/authContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import controlContext from "../../context/control/controlContext";
import OPDList from "../../components/opdList/OPDList";
import OPDForm from "../../components/opdForm/OPDForm";
import FilterScreen from "../../components/filterScreen/FilterScreen";
import AddFilter from "../../components/addFilter/AddFilter";
import SearchInput from "../../components/searchInput/SearchInput";
import { createEstructuraOPD } from "../../utils/estructuras";
import { STATES, ALERTSProcedimientosProgramados, TIPPROCS } from "../../utils/states";
import { getFiles } from "../../api/transactionDocuments";

import './OPD.css';

const OPD = () => {
    const [showABM, setShowABM] = useState(true);
    const [opdToModify, setOpdToModify] = useState({});
    const [loading, setLoading] = useState(true);
    const [opdFiltradas, setOpdFiltradas] = useState(undefined);
    const [showFilters, setShowFilters] = useState(false);
    const [select, setSelect] = useState([]);
    const [filterTipoActivos, setFilterTipoActivos] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState({ todos: 0, abiertas: 1, pendientes: 0, enproceso: 0, finalizadas: 0 });
    const [vistaActivo, setVistaActivo] = useState(false);

    const oContext = useContext(opdContext);
    const { opdList, actualizarOPDList } = oContext;

    const auContext = useContext(authContext);
    const { usuario } = auContext;

    const uContext = useContext(usuariosContext);
    const { userListView, actualizarUserListView } = uContext;

    const ctrlContext = useContext(controlContext);
    const {
        filtrosRango,
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        filtrar
    } = ctrlContext;

    const aplicarFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    };

    const handlerInicializarFiltros = async () => {
        const statesOPD = ['PENDIENTE', 'ENPROCESO']; // Arrancar con ABIERTAS
        const tipoAlerta = ALERTSProcedimientosProgramados;
        let statesProcs = ['PEND', 'PROG', 'COMPL'];
        await iniciarFiltros(statesOPD, usuario, tipoAlerta, TIPPROCS, 'OPD', statesProcs);
    };

    useEffect(() => {
        if (usuario) actualizarUserListView(usuario);
        handlerInicializarFiltros();
        actualizarOPDList()
            .then(res => {
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (opdList != undefined && opdList != null) {
            let opdFiltradasToSet = filtrar(opdList, filtrosEstado, filtrosRango, 'OPD');
            setOpdFiltradas(opdFiltradasToSet);
        }
    }, [opdList, filtrosEstado, filtrosRango]);

    const handleClickAdd = () => {
        setOpdToModify({});
        setShowABM(false);
    };

    const [filesForEdit, setFilesForEdit] = useState([]);

    const handleClickEdit = async (opd) => {
        try {
            const resp = await getFiles(opd.tDocCodFor, opd.tDocNroFor);
            setFilesForEdit(resp.data.data || []);
        } catch (error) {
            console.log("Error al cargar archivos de la OPD", error);
            setFilesForEdit([]);
        }
        setOpdToModify(opd);
        setShowABM(false);
    };

    const handleCerrarForm = () => {
        setOpdToModify({});
        setFilesForEdit([]);
        setShowABM(true);
    };

    const handleToggleVistaActivo = (newValue) => {
        setVistaActivo(newValue);
        if (newValue) {
            // En vista por activo: solo revisadas
            const filterEstado = { ...filtrosEstado, revisadaProduccion: [true] };
            aplicarFiltros({ filterEstado, filterRango: filtrosRango });
        } else {
            // En vista normal: ambos tildados
            const filterEstado = { ...filtrosEstado, revisadaProduccion: [false, true] };
            aplicarFiltros({ filterEstado, filterRango: filtrosRango });
        }
    };

    return (
        <div className="opdPage">
            {showABM ? (
                loading ? (
                    <h3 className='warningStatusMsg'>
                        Cargando<span>.</span><span>.</span><span>.</span>
                    </h3>
                ) : (
                    <OPDList
                        opdList={opdFiltradas}
                        handleClickAdd={handleClickAdd}
                        handleClickEdit={handleClickEdit}
                        usuario={usuario}
                        showFilters={showFilters}
                        setShowFilters={setShowFilters}
                        filtros={{ filtrosRango, filtrosEstado }}
                        aplicarFiltros={aplicarFiltros}
                        activeWorkSpace={activeWorkSpace}
                        setActiveWorkSpace={setActiveWorkSpace}
                        vistaActivo={vistaActivo}
                        setVistaActivo={handleToggleVistaActivo}
                    />
                )
            ) : (
                <OPDForm
                    opdToModify={opdToModify}
                    cerrar={handleCerrarForm}
                    usuario={usuario}
                    files={filesForEdit}
                />
            )}

            {showFilters && <div className="filterContainer">
                <AddFilter
                    usuarios={userListView}
                    item={selectedFilter}
                    cerrar={setShowFilters}
                    filtro={{ filtrosRango, filtrosEstado }}
                    aplicarFiltros={aplicarFiltros}
                    workspace={activeWorkSpace}
                    selct={select}
                    setSelec={setSelect}
                    filterTipoActivos={filterTipoActivos}
                    setFilterTipoActivos={setFilterTipoActivos}
                    componentePadre="OPD"
                    vistaActivo={vistaActivo}
                />
            </div>}
        </div>
    );
};

export default OPD;
